import { useMutation, useQuery } from "@tanstack/react-query";

import { IDanceSchool } from "../models";
import { cleanApiResponse } from "../utils";
import { IBasicAuthDanceSchoolEnrolStudentRequest } from "../models/EnrolmentFormData";

enum QueryKeys {
  Timetable = "timetable",
  DanceSchool = "DanceSchoolQueryKey"
}

//#region DANCE WORLD API
const DANCE_WORLD_API_BASE_URL = process.env.REACT_APP_DANCE_WORLD_API_BASE_URL!;
const DANCE_WORLD_BASIC_AUTH_USERNAME = process.env.REACT_APP_DANCE_WORLD_BASIC_AUTH_USERNAME!;
const DANCE_WORLD_BASIC_AUTH_PASSWORD = process.env.REACT_APP_DANCE_WORLD_BASIC_AUTH_PASSWORD!;
const DANCE_WORLD_BASIC_AUTH = btoa(`${DANCE_WORLD_BASIC_AUTH_USERNAME}:${DANCE_WORLD_BASIC_AUTH_PASSWORD}`);
//#endregion DANCE WORLD API

export const useGetDanceSchool = () => {
  return useQuery<IDanceSchool, Error>({
    queryKey: [QueryKeys.DanceSchool],
    queryFn: async () => {
      const result = await fetch(`${DANCE_WORLD_API_BASE_URL}/v1/basic-auth/dance-schools`, {
        headers: {
          Authorization: `Basic ${DANCE_WORLD_BASIC_AUTH}`
        }
      });
      const jsonData = await result.json();

      return cleanApiResponse(jsonData) as IDanceSchool;
    }
  })
}

export const useSubmitEnrolmentFormMutation = (onSuccess: () => void, onError: () => void) => {

  const submitForm = async (request: IBasicAuthDanceSchoolEnrolStudentRequest): Promise<boolean> => {
    const result = await fetch(`${DANCE_WORLD_API_BASE_URL}/v1/basic-auth/dance-schools/enrol`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${DANCE_WORLD_BASIC_AUTH}`
      },
      body: JSON.stringify(request)
    });

    if (result.status >= 200 && result.status < 300) {
      return true;
    }

    throw new Error(`API Call failed with status: ${result.status}`);
  }

  return useMutation<boolean, Error, IBasicAuthDanceSchoolEnrolStudentRequest>({
    mutationFn: submitForm,
    onSuccess,
    onError
  })
}